// Vendor libraries
import { ChangeDetectorRef, ElementRef, EventEmitter, } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SavedItemDropdownAction } from 'NewAngular/features/components/saved-items/enums/saved-item-dropdown-action.enum';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
// Services
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import { FolderOperationsService } from 'FoldersApp/services/folder-operations.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { ToastMessagesService } from 'NewAngular/features/components/toast-messages/toast-messages.service';
// NgRx
import { setSelectedFolderableOperation } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.action';
import { setFolderableOperation } from 'FoldersApp/state/folderable-operation/folderable-operation.action';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "NewAngular/services/dropdown-helper.service";
import * as i3 from "FoldersApp/services/folder-operations.service";
import * as i4 from "FoldersApp/services/selected-folderable.service";
import * as i5 from "NewAngular/features/components/toast-messages/toast-messages.service";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "@angular/forms";
import * as i9 from "../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
const _c0 = a0 => ({ show: a0 });
function FolderableSavedItemDropdownComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.item.name);
} }
function FolderableSavedItemDropdownComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.defaultName);
} }
function FolderableSavedItemDropdownComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1, "(unsaved)");
    i0.ɵɵelementEnd();
} }
function FolderableSavedItemDropdownComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1, "(edited)");
    i0.ɵɵelementEnd();
} }
function FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
} }
function FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_3_Conditional_1__svg_svg_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 9);
} if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("name", option_r3.icon);
} }
function FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_3_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_3_Conditional_1__svg_svg_0_Template, 1, 1, "svg", 12);
} if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngIf", option_r3.icon);
} }
function FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_3_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
} }
function FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵlistener("click", function FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_3_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r2); const option_r3 = i0.ɵɵnextContext().$implicit; const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.dropdownHandler(option_r3)); });
    i0.ɵɵtemplate(1, FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_3_Conditional_1_Template, 1, 1, ":svg:svg", 9)(2, FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_3_Conditional_2_Template, 1, 0, "div", 10);
    i0.ɵɵelement(3, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("disabled", option_r3.disabled);
    i0.ɵɵadvance();
    i0.ɵɵconditional(option_r3.icon ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", option_r3.label)("disabled", option_r3.disabled);
} }
function FolderableSavedItemDropdownComponent_Conditional_7_For_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "div");
    i0.ɵɵtemplate(2, FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_2_Template, 1, 0, "div", 6)(3, FolderableSavedItemDropdownComponent_Conditional_7_For_2_Conditional_3_Template, 4, 4, "a", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(option_r3.type === "divider" ? 2 : option_r3.type === "option" ? 3 : -1);
} }
function FolderableSavedItemDropdownComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵrepeaterCreate(1, FolderableSavedItemDropdownComponent_Conditional_7_For_2_Template, 4, 1, "span", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.dropdownOptions);
} }
/**
 * Component that handles common operations for saved folderable items.
 * Parent components can handle app specific behavior by listening for events from `dropdownOperation`.
 */
export class FolderableSavedItemDropdownComponent {
    constructor(store, changeDetectorRef, dropdownHelperService, eltRef, folderOperationsService, selectedFolderableService, toastMessagesService) {
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.dropdownHelperService = dropdownHelperService;
        this.eltRef = eltRef;
        this.folderOperationsService = folderOperationsService;
        this.selectedFolderableService = selectedFolderableService;
        this.toastMessagesService = toastMessagesService;
        this.unsubscribe = new Subject();
        this.dropdownOperation = new EventEmitter();
        this.showDropdown = false;
        this.dropdownOptions = [];
        this.item = null;
        this.folderableItemName = '';
        this.isRenaming = false;
        this.lastKeyDown = null;
        this.nameMaxLength = 255;
    }
    ngOnInit() {
        this.selectedFolderableService.selectedFolderable$.pipe(takeUntil(this.unsubscribe)).subscribe((folderable) => {
            this.item = folderable?.item || null;
            this.folderableItemName = folderable?.item.name || '';
        });
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.showDropdown) {
                this.showDropdown = false;
            }
        };
        this.dropdownHelperService.setCloseHandler(this.eltRef.nativeElement.parentElement, autoCloseHandler);
    }
    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
    toggleDropdown() {
        this.showDropdown = !this.showDropdown;
        this.changeDetectorRef.detectChanges();
    }
    dropdownHandler(option) {
        this.showDropdown = false;
        // If there is a selected item, handle common selected item operations
        if (this.item) {
            switch (option.value) {
                case SavedItemDropdownAction.DELETE:
                    const selectedFolderableItem = {
                        id: this.item.id,
                        name: this.item.name,
                        // The name of the backend Model
                        itemType: this.itemType,
                        // A human-readable description of the item type
                        itemTypeDescription: this.itemTypeDescription,
                        ancestorFolderId: this.ancestorFolderId,
                        sharing: this.item.sharing,
                    };
                    this.store.dispatch(setSelectedFolderableOperation({
                        selectedOperation: {
                            item: selectedFolderableItem,
                            operation: this.parseOperationName(option.value),
                        },
                    }));
                    return;
                case SavedItemDropdownAction.RENAME:
                    this.isRenaming = true;
                    // Wait for input box to be rendered before attempting find and focus the element.
                    setTimeout(() => {
                        const el = document.querySelector(`#folderableItemNameInput`);
                        if (el)
                            el.focus();
                    });
                    return;
                default:
            }
        }
        // Handle other common operations
        switch (option.value) {
            case SavedItemDropdownAction.OPEN:
            case SavedItemDropdownAction.SAVE_AS:
                this.store.dispatch(setFolderableOperation({
                    operation: this.parseOperationName(option.value),
                }));
                return;
            default:
        }
        // Let the parent component handle app specific operations
        if (option.value !== null) {
            this.dropdownOperation.emit(option.value);
            return;
        }
        // We do not expect to get here
        throw new Error(`Unexpected dropdown option: ${option.value}`);
    }
    parseOperationName(input) {
        const match = input.match(/(.*?)(?=SavedItem)/);
        if (match === null)
            throw new Error(`Unexpected operation name ${input}.`);
        return match[1];
    }
    blurHandler() {
        if (this.lastKeyDown === 'Enter') {
            // If the blur was triggered by the enter key, ignore the event because it was already handled.
            return;
        }
        this.renameItem();
    }
    enterHandler(event) {
        this.lastKeyDown = event.key;
        // Enter also triggers a blur event.
        // Delay clearing lastKeyDown to allow `blurHandler` to run.
        setTimeout(() => {
            this.lastKeyDown = null;
        });
        this.renameItem();
    }
    renameItem() {
        this.isRenaming = false;
        if (this.item === null) {
            return;
        }
        this.folderableItemName = this.folderableItemName.trim();
        if (this.folderableItemName === '' || this.folderableItemName === this.item.name) {
            this.folderableItemName = this.item.name;
            return;
        }
        const itemId = this.item.id;
        if (this.renameSubscription)
            this.renameSubscription.unsubscribe();
        this.renameSubscription = this.folderOperationsService
            .renameFolderableItem(this.itemType, itemId, this.folderableItemName)
            .subscribe({
            next: (response) => {
                // Updated the selected folderable with the new name to avoid making an additional request for
                // folderable info (because only the name has changed).
                this.selectedFolderableService.updateSelectedFolderableItem({
                    name: this.folderableItemName,
                });
                this.toastMessagesService.addMessage(response.message);
            },
            error: (response) => {
                this.folderableItemName = this.item?.name || '';
                this.toastMessagesService.addMessage(response.error.error_message, ToastMessageType.ERROR);
            },
        });
    }
}
FolderableSavedItemDropdownComponent.ɵfac = function FolderableSavedItemDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableSavedItemDropdownComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.DropdownHelperService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i3.FolderOperationsService), i0.ɵɵdirectiveInject(i4.SelectedFolderableService), i0.ɵɵdirectiveInject(i5.ToastMessagesService)); };
FolderableSavedItemDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderableSavedItemDropdownComponent, selectors: [["ycn-folderable-saved-item-dropdown"]], inputs: { itemType: "itemType", itemTypeDescription: "itemTypeDescription", defaultName: "defaultName", ancestorFolderId: "ancestorFolderId", itemIsEdited: "itemIsEdited", dropdownOptions: "dropdownOptions", nameMaxLength: "nameMaxLength" }, outputs: { dropdownOperation: "dropdownOperation" }, standalone: false, decls: 8, vars: 10, consts: [[3, "ngClass"], ["id", "folderableItemNameInput", "role", "button", 1, "form-control", "page-name", "is-editing", 3, "ngModelChange", "blur", "keydown.enter", "maxLength", "hidden", "ngModel"], ["href", "javascript:void(0)", 1, "dropdown-toggle", "dropdown-toggle-lg", "page-name", "user-select-none", 3, "click", "hidden"], [1, "page-name-text", 3, "textContent"], [1, "page-name-label"], [1, "dropdown-menu-with-icons", "dropdown-menu", "show"], [1, "dropdown-divider"], ["href", "javascript:void(0)", "ycnDisabled", "", 1, "dropdown-item", 3, "disabled"], ["href", "javascript:void(0)", "ycnDisabled", "", 1, "dropdown-item", 3, "click", "disabled"], ["ycnIcon", "", 3, "name"], [1, "icon"], ["ycnDisabled", "", 1, "dropdown-item-text", 3, "textContent", "disabled"], ["ycnIcon", "", 3, "name", 4, "ngIf"]], template: function FolderableSavedItemDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "input", 1);
        i0.ɵɵtwoWayListener("ngModelChange", function FolderableSavedItemDropdownComponent_Template_input_ngModelChange_1_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.folderableItemName, $event) || (ctx.folderableItemName = $event); return $event; });
        i0.ɵɵlistener("blur", function FolderableSavedItemDropdownComponent_Template_input_blur_1_listener() { return ctx.blurHandler(); })("keydown.enter", function FolderableSavedItemDropdownComponent_Template_input_keydown_enter_1_listener($event) { return ctx.enterHandler($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "a", 2);
        i0.ɵɵlistener("click", function FolderableSavedItemDropdownComponent_Template_a_click_2_listener() { return ctx.toggleDropdown(); });
        i0.ɵɵtemplate(3, FolderableSavedItemDropdownComponent_Conditional_3_Template, 1, 1, "span", 3)(4, FolderableSavedItemDropdownComponent_Conditional_4_Template, 1, 1, "span", 3)(5, FolderableSavedItemDropdownComponent_Conditional_5_Template, 2, 0, "span", 4)(6, FolderableSavedItemDropdownComponent_Conditional_6_Template, 2, 0, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, FolderableSavedItemDropdownComponent_Conditional_7_Template, 3, 0, "div", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx.showDropdown));
        i0.ɵɵadvance();
        i0.ɵɵproperty("maxLength", ctx.nameMaxLength)("hidden", !ctx.isRenaming);
        i0.ɵɵtwoWayProperty("ngModel", ctx.folderableItemName);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.isRenaming);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.item ? 3 : 4);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!ctx.item || (ctx.item == null ? null : ctx.item.id) === null ? 5 : ctx.itemIsEdited ? 6 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.showDropdown ? 7 : -1);
    } }, dependencies: [i6.NgClass, i6.NgIf, i7.IconDirective, i8.DefaultValueAccessor, i8.NgControlStatus, i8.NgModel, i9.DisabledDirective], encapsulation: 2 });
